import React, { useContext } from 'react';
import { connect } from 'react-redux';
import TableRow from '@material-ui/core/TableRow';
import LeadsContext from '@/modules/leads/contexts/LeadsContext';
import TableCellOrder from '@/modules/common/components/TableCellOrder';

const RowOrder = (props) => {
    // noinspection JSCheckFunctionSignatures
    const leadsContext = useContext(LeadsContext);

    return (
        <TableRow id="row-order">
            <TableCellOrder className="adv_sub" orderName="adv_sub" ordering={leadsContext.ordering}>
                ID заявки
            </TableCellOrder>
            <TableCellOrder className="offer" orderName="offer__offer_name" ordering={leadsContext.ordering}>
                Оффер
            </TableCellOrder>
            {(!props.user.affiliate)
                ? <TableCellOrder className="affiliate_name" orderName="affiliate_name"
                                  ordering={leadsContext.ordering}>
                    Имя партнера
                </TableCellOrder>
                : null
            }
            {(leadsContext.cols.type)
                ? <TableCellOrder className="type" orderName="type__name" ordering={leadsContext.ordering}>
                    Тип заявки
                </TableCellOrder>
                : null
            }
            <TableCellOrder className="datetime" orderName="datetime" ordering={leadsContext.ordering}>
                Дата/Время
            </TableCellOrder>
            <TableCellOrder className="source" orderName="source" ordering={leadsContext.ordering}>
                Source
            </TableCellOrder>
            <TableCellOrder className="aff_sub" orderName="aff_sub" ordering={leadsContext.ordering}>
                            Affiliate Sub
            </TableCellOrder>
            {(leadsContext.cols.advSub2)
                ? <TableCellOrder className="adv_sub2" orderName="adv_sub2" ordering={leadsContext.ordering}>
                    Adv Sub
                </TableCellOrder>
                : null
            }
            {(leadsContext.cols.dts)
                ? <TableCellOrder className="datetime_status" orderName="datetime_status"
                                  ordering={leadsContext.ordering}
                >
                    Дата/Время статуса
                </TableCellOrder>
                : null
            }
            <TableCellOrder className="status" orderName="status__internal" ordering={leadsContext.ordering}>
                Статус
            </TableCellOrder>
            <TableCellOrder className="price" orderName="price__price" ordering={leadsContext.ordering}>
                Стоимость
            </TableCellOrder>
            {(leadsContext.cols.transactionId)
                ? <TableCellOrder className="transaction_id" orderName="transaction_id"
                                  ordering={leadsContext.ordering}
                >
                    ID транзакции
                </TableCellOrder>
                : null
            }
        </TableRow>
    );
};

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    null
)(RowOrder);
